module.exports = __webpack_public_path__ + "static/media/rupee.f89d0c27.svg";